import { pageTitle } from 'ember-page-title';
import Layout from 'tutorial/components/layout.gts';

<template>
  {{pageTitle "Glimmer tutorial"}}

  <Layout />
</template>
